module.exports = __webpack_public_path__ + "static/media/video3.5662a4fa.png";